import { GQuery, useLazyQuerySaga } from 'hooks/useQuerySaga';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Product, QueryProductSearchArgs } from 'types/schema';
import { productSearch } from 'utils/query';

export function useProductSearch() {
  const [search] = useLazyQuerySaga<GQuery<'productSearch'>, QueryProductSearchArgs>(productSearch, {
    // TODO: check
    authentication: false,
  });
  const [results, setResults] = useState<Product[]>([]);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const searchProducts = useCallback(
    (query: string) => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      if (!query.trim()) {
        setResults([]);
        return;
      }
      debounceRef.current = setTimeout(async () => {
        const regionCode = window.localStorage.getItem('region') || 'HCM';
        try {
          const data = await search({
            variables: {
              sort: [],
              filter: { query: query.trim(), regionCode: regionCode },
              pagination: { page: 0, size: 50 },
            },
          });
          setResults((data?.data ?? []).filter(Boolean) as Product[]);
        } catch {
          setResults([]);
        }
      }, 300);
    },
    [search],
  );

  useEffect(
    () => () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    },
    [],
  );

  return { results: results, searchProducts: searchProducts, clearResults: () => setResults([]) };
}
